import { render, staticRenderFns } from "./mainFAQs.vue?vue&type=template&id=c35ef43c&scoped=true"
import script from "./mainFAQs.vue?vue&type=script&lang=js"
export * from "./mainFAQs.vue?vue&type=script&lang=js"
import style0 from "./mainFAQs.vue?vue&type=style&index=0&id=c35ef43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35ef43c",
  null
  
)

export default component.exports